import type { MeContext } from '@vizit/api';
import { landingDecisionToRoute } from './resolve-fallback-route';
import { resolveLanding } from './resolve-landing';

export function canAccessPortfolioGrid(context: MeContext): boolean {
  return resolveLanding(context).type === 'portfolioPicker';
}

export function canAccessFlatWorkspaceGrid(context: MeContext): boolean {
  return resolveLanding(context).type === 'flatWorkspacePicker';
}

export function resolveOrganizationGridHref(context: MeContext): string | null {
  const decision = resolveLanding(context);

  return decision.type === 'workspace' ? null : landingDecisionToRoute(decision);
}
